import type { InjectionKey, Ref } from 'vue'
import { inject } from 'vue'
import useUrlStorage from '@app/shared/vue/composables/use-url-storage'

export const INBOX_IN_MODAL: InjectionKey<boolean> = Symbol('inboxInModal')

export default function useInboxUrlStorage<T>(
  key: string,
  initialValue: T,
  serialize: (value: T) => string
): Ref<T> {
  const inModal = inject(INBOX_IN_MODAL, false)
  return useUrlStorage(key, initialValue, serialize, { syncToUrl: !inModal })
}
